<div class="payment-card">
  @if (title) {
  <p class="payment-card-title">{{ title }}</p>
  }
  @if (loading && !options.length) {
  <p class="payment-loading">Loading…</p>
  } @else {
  <div class="payment-options">
    @for (method of options; track method.value) {
    <button type="button" class="payment-option" [class.active]="value === method.value"
      (click)="select(method.value)">
      <span class="payment-option-name">{{ method.label }}</span>
      <span class="payment-option-check" aria-hidden="true"></span>
    </button>
    }
  </div>
  }
</div>
